module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.findindex/~/es-abstract/helpers/isNaN.js
// module id = 208
// module chunks = 2